var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EzCategoryDropdown',{ref:"select",class:['category-dropdown'],attrs:{"data":_vm.listedCategories,"name":_vm.name,"disabled":_vm.disabled,"isFullWidth":_vm.isFullWidth,"selected":_vm.selected,"is-parent-disabled":_vm.isParentDisabled,"label":_vm.label,"data-cy":_vm.dataCy},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }